export default __webpack_public_path__ + "static/media/location.34365447.png";